import type { Hours } from './types';

const DAYS = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'] as const;

/** Current time in India (the site's locale) as weekday + minutes since midnight. */
function nowInIndia(now = new Date()) {
  const parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Asia/Kolkata', weekday: 'short', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).formatToParts(now);
  const get = (t: string) => parts.find((p) => p.type === t)?.value ?? '';
  const day = get('weekday').toLowerCase().slice(0, 3) as (typeof DAYS)[number];
  return { day, minutes: Number(get('hour')) * 60 + Number(get('minute')) };
}

const toMin = (t?: string) => (t ? Number(t.slice(0, 2)) * 60 + Number(t.slice(3, 5)) : NaN);
export const fmt12 = (t?: string) => {
  if (!t) return '';
  const h = Number(t.slice(0, 2));
  const m = t.slice(3, 5);
  return `${h % 12 || 12}${m !== '00' ? `:${m}` : ''} ${h < 12 ? 'AM' : 'PM'}`;
};

/** Open/closed status computed from real opening hours. Returns null when hours are unknown. */
export function openStatus(hours?: Hours[], now = new Date()): { open: boolean; label: string } | null {
  if (!hours?.length) return null;
  const { day, minutes } = nowInIndia(now);
  const today = hours.find((h) => h.day === day);
  if (!today) return null;
  if (today.closed) return { open: false, label: 'Closed today' };
  const o = toMin(today.open);
  const c = toMin(today.close);
  if (isNaN(o) || isNaN(c)) return null;
  const range = `${fmt12(today.open)} – ${fmt12(today.close)}`;
  const isOpen = c > o ? minutes >= o && minutes < c : minutes >= o || minutes < c;
  return { open: isOpen, label: isOpen ? `Open · ${range}` : `Closed · opens ${fmt12(today.open)}` };
}
